import { Link, LinkProps } from "react-router-dom";
import { AnchorHTMLAttributes } from "react";

interface CustomLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement> & LinkProps, "to"> {
  to: string;
}

export const CustomLink = (props: CustomLinkProps): JSX.Element => {
  const { to, ...otherProps } = props;
  return to.includes("http") ? (
    <a href={to} target={"_blank"} rel={"noreferrer"} {...otherProps} />
  ) : (
    <Link to={to} {...otherProps} />
  );
};
